import AntIcon from "@/components/icons/AntIcon";
import { Button, Popconfirm, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useToggleAgentCommissionsOutput } from "../../../../common/api/queries";
import { CommissionsOutput } from "../../batch/types";

type Props = {
  onFinish: () => void;
  selectedOutputs: CommissionsOutput[];
};

export const CommissionsOutputsTogglePaidActions = ({ onFinish, selectedOutputs }: Props) => {
  const { t } = useTranslation();

  const paidInBatchOutputs = selectedOutputs.filter((output) => output.paidInBatch);
  const notPaidInBatchOutputs = selectedOutputs.filter((output) => !output.paidInBatch);

  const toggleAgentCommissionsOutput = useToggleAgentCommissionsOutput();

  return (
    <Space>
      <Popconfirm
        title={t("commissions.outputs.helpers.paidInBatchConfirm")}
        icon={<AntIcon type="question" />}
        okText={t("common.yes")}
        cancelText={t("common.no")}
        okType="primary"
        disabled={!notPaidInBatchOutputs.length}
        onConfirm={() => {
          toggleAgentCommissionsOutput.mutate(
            {
              entries: notPaidInBatchOutputs.map((output) => ({
                id: output.id,
                optimisticLockVersion: output.optimisticLockVersion,
              })),
            },
            { onSuccess: onFinish },
          );
        }}
      >
        <Button size="small" variant="outlined" color="green" disabled={!notPaidInBatchOutputs.length}>
          {notPaidInBatchOutputs.length
            ? `${t("commissions.batch.helpers.markAsPaid")} (${notPaidInBatchOutputs.length})`
            : t("commissions.batch.helpers.markAsPaid")}
        </Button>
      </Popconfirm>

      <Popconfirm
        title={t("commissions.outputs.helpers.notPaidInBatchConfirm")}
        icon={<AntIcon type="question" />}
        okText={t("common.yes")}
        cancelText={t("common.no")}
        okType="primary"
        disabled={!paidInBatchOutputs.length}
        onConfirm={() => {
          toggleAgentCommissionsOutput.mutate(
            {
              entries: paidInBatchOutputs.map((output) => ({
                id: output.id,
                optimisticLockVersion: output.optimisticLockVersion,
              })),
            },
            { onSuccess: onFinish },
          );
        }}
      >
        <Button size="small" variant="outlined" color="orange" disabled={!paidInBatchOutputs.length}>
          {paidInBatchOutputs.length
            ? `${t("commissions.batch.helpers.markAsUnPaid")} (${paidInBatchOutputs.length})`
            : t("commissions.batch.helpers.markAsUnPaid")}
        </Button>
      </Popconfirm>
    </Space>
  );
};
